import { Link } from "@tanstack/react-router"
import clsx from "clsx"
import type { IProps, TVoxPillVariant } from "./interfaces"
import classes from "./styles.module.css"

const VARIANT_CLASSES: Record<TVoxPillVariant, string> = {
  arcane: classes.arcane,
  grimoire: classes.grimoire,
  record: classes.record,
}

/**
 * Pill-shaped, Cinzel UPPERCASE wide-tracked button — the ritual CTA
 * voice from the Voxcanon design language. Three flavours:
 *   - `arcane` → primary CTA, theme-aware gradient fill
 *   - `grimoire` → secondary outline (dashed on parchment)
 *   - `record` → destructive / start-recording, crimson
 */
export const VoxPillButton = ({
  variant = "arcane",
  leading,
  onClick,
  children,
  href,
  disabled,
  className,
  "aria-label": ariaLabel,
}: IProps): React.JSX.Element => {
  const composed = clsx(classes.pill, VARIANT_CLASSES[variant], className)
  const body = (
    <>
      {leading && <span className={classes.leading}>{leading}</span>}
      <span>{children}</span>
    </>
  )

  if (href) {
    return (
      <Link to={href} className={composed} aria-disabled={disabled || undefined} aria-label={ariaLabel}>
        {body}
      </Link>
    )
  }

  return (
    <button type="button" className={composed} onClick={onClick} disabled={disabled} aria-label={ariaLabel}>
      {body}
    </button>
  )
}
